// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1qY7x","label":"Labeled_label__1Y5Z9","divider":"Labeled_divider__3htgM"};